<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <product-model-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></product-model-create>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProductModelCreate from './ProductModelCreate.vue'

export default {
  components: {
    VuexBreadcrumb,
    ProductModelCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>